import React, {
  useState,
  useRef,
  useEffect,
  useMemo,
  useCallback,
} from "react";
import { useMutation } from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import CustomForm from "components/Common/Form";
import { AREA_FORM_CONFIG } from "./config";
import { useAlert } from "context/alert";
import { createArea, updateArea } from "services/area";
import { useSelector } from "react-redux";
import zoneLocalStorageId from "utils/zone";
import Loader from "components/Common/loader";

const AddArea = ({ onClose, rowData }) => {
  const jwtAuthreducer = useSelector((state) => state.jwtAuthreducer);
  const {
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: useMemo(() => {
      return rowData;
    }, [rowData]),
  });
  const { showAlert } = useAlert();

  const onSuccess = () => {
    const refetchBranches = true;
    const message = rowData
      ? "Area updated successfully!"
      : "Area created successfully!";
    showAlert(message, "success");

    onClose(refetchBranches);
  };

  const onError = useCallback((error) => {
    const errorMessage =
      error?.response?.data?.message || "Something went wrong!";
    const errorDetail = error?.response?.data?.detail;
    showAlert(errorMessage, "danger", errorDetail);
  }, []);

  const { mutate: addBranchMutate, isLoading: isLoadingAdd } = useMutation({
    mutationFn: createArea,
    onSuccess,
    onError,
  });

  const { mutate: updateBranchMutate, isLoading: isLoadingUpdate } =
    useMutation({
      mutationFn: updateArea,
      onSuccess,
      onError,
    });

  const isSubmitting = isLoadingAdd || isLoadingUpdate;

  const SubmitBranch = async (values, e) => {
    e.preventDefault();
    console.log("values", values);
    const payload = {
      ...values,
      id: rowData?.id,
      state_id: values?.state_id,
      zone_id: values?.zone_id || zoneLocalStorageId(),
      created_by: jwtAuthreducer.user.employee_code_id,
      country_code: "IN",
    };

    if (rowData) {
      updateBranchMutate({
        ...rowData,
        ...payload,
        id: payload.id || rowData.id,
      });
    } else {
      addBranchMutate(payload);
    }

    reset();
  };

  useEffect(() => {
    reset(rowData);
  }, [rowData, reset]);

  return (
    <div style={{ position: "relative" }}>
      {isSubmitting && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(255, 255, 255, 0.7)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10,
          }}
        >
          <Loader isLoading={true} />
        </div>
      )}
      <CustomForm
        config={AREA_FORM_CONFIG(rowData)}
        onSubmit={SubmitBranch}
        columnCount={2}
        rowData={rowData}
        disabled={isSubmitting}
      />
    </div>
  );
};

export default AddArea;
